import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import * as authRoutines from './Containers/Auth/authRoutines';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { Redirect, Route } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { isEmpty } from './helpers/isEmpty';
import { useDispatch, useSelector } from 'react-redux';
import useFusionAuthRefreshToken from "./Hooks/useFusionAuthRefreshToken";
import { useStyles } from './styles/toast';
import AuthCallback from './Components/AuthCallback'
import Layout from './Components/Layout';
import Loading from './Components/Loading/';
import Login from './Containers/Auth';
import PlatformRoutes from './PlatformRoutes/';
import React from 'react';

import SimpleDialog from './Components/Atoms/SimpleDialog/';
import Topbar from './Components/Navigation/Topbar/';
import theme from './globals/theme/';
import {useFusionAuth} from "@fusionauth/react-sdk";

declare global {
    interface Window { refreshToken: any; }
}

const Routes = () => {
    const {isAuthenticated} = useFusionAuth()
    const dispatch = useDispatch();

    const authModalStatus = useSelector((state: any) => state.auth.reauthModalStatus);
    return (
        <React.Fragment>
            <SimpleDialog
                hideCancel={true}
                onCancel={() => {}}
                onOk={() => {
                    dispatch(authRoutines.commandCenterLogout());
                    dispatch(authRoutines.reauthModalStatus(false));
                }}
                open={authModalStatus}
                title="Reauthentication necessary"
            >
                Your session has expired. Please logout and log back in.
            </SimpleDialog>
            <Route
                exact
                path="/"
                render={() => {
                    return isAuthenticated ? (
                        <Redirect to="/loading" />
                    ) : (
                        <Redirect to="/login" />
                    );
                }}
            />
            <Route component={Loading} exact path="/loading" />
            <Route exact path="/auth/callback" render={() => <AuthCallback  />} />
            <Route exact path="/events" render={() => <Topbar minimal={true} />} />
            <PlatformRoutes />
        </React.Fragment>
    );
};
function App() {
    const {init} = useFusionAuthRefreshToken()
    init()
    const toastClasses = useStyles();
    return (
        <MuiThemeProvider theme={theme}>
            <div className="App">
                <Route component={Login} exact path="/login" />
                <Layout>
                    <Routes />
                </Layout>
                <ToastContainer
                    autoClose={2000}
                    position={toast.POSITION.TOP_CENTER}
                    toastClassName={toastClasses.toastContainer}
                />
            </div>
        </MuiThemeProvider>
    );
}

export default App;
